export enum STATE_ORDER {
    CREATED = 'Creado',
    PICKING_PENDING = 'Pendiente de Picking',
    CANCELLED = 'Cancelado',
    IN_CONSOLIDATION = 'En Consolidacion',
    TO_CONSOLIDATE = 'Por consolidar',
    RE_ENTRY = 'Reingreso',
    CONSOLIDATED = 'Consolidado',
    PRE_CANCELED = 'Pre-cancelado',
    ASSIGNED = 'Asignado',
    PRE_DISPATCH = 'Pre-despacho',
    TO_WITHDRAW = 'Por Retirar',
    TO_LOCATE = 'Por Ubicar',
    TO_DISPATCH = 'Por Despachar'
}
